module.exports = __webpack_public_path__ + "img/accenture.9ed620c8.png";